import { Grid, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Button from "@mui/material/Button"; // Import Button from Material-UI
import { useState } from "react";
import EfficacyInstructions from "../ingredients/EfficacyInstructions";
import { getEfficacyImages } from "../../helpers/appUtils";
import { useTranslation } from "react-i18next";

const styles = { fontColor: "#343a40", lineColor: "#f8f9fa" };

export const Subsection = ({ text, item, displayText }) => {
  const { t } = useTranslation();
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false);
  const [imagePaths, setImagePaths] = useState([]);

  const handleOpenInstructions = () => {
    const _imagePaths = getEfficacyImages(item);
    setIsInstructionsOpen(true);
    setImagePaths(_imagePaths);
  };

  const handleCloseInstructions = () => {
    setIsInstructionsOpen(false);
  };

  return (
    <Grid container wrap="nowrap" spacing={2}>
      <Grid item xs md={12}>
        <Typography
          variant="h6"
          fontWeight={"600"}
          marginBottom={"10px"}
          color={styles.fontColor}
          display="flex"
          alignItems="center"
        >
          {text}
          {/* Render the icon within a clickable Button */}
          {text === t("dashboard.ingredientDetails.heading.h4") && (
            <Button
              onClick={handleOpenInstructions}
              style={{ minWidth: "auto" , marginLeft: 4 }}
            >
              <HelpOutlineIcon />
            </Button>
          )}
          
          {/* Render the 'item' prop if it exists (This is for the antimicrobian column requested) */}
          {/* {displayText && (
            <Typography variant="body2" color="textSecondary">
              {displayText}
            </Typography>
          )} */}

          {displayText && (
            <span style={{ fontWeight: "normal", marginLeft: 8 }}>
              - ({displayText})
            </span>
          )}


          <hr color={styles.lineColor} />
        </Typography>
      </Grid>

      <EfficacyInstructions
        open={isInstructionsOpen}
        onClose={handleCloseInstructions}
        imagePaths={imagePaths}
      />
    </Grid>
  );
};
